import React, { Component } from 'react'
import Helmet from 'react-helmet'
import SupportEmail from '../components/SupportEmail.js'

import Layout from '../components/layout.js'

const encode = data => Object
  .keys(data)
  .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
  .join('&')

// const ContactForm = (
//   <form
//     name="contact"
//     method="post"
//     action="/thanks"
//     data-netlify="true"
//     data-netlify-honeypot="bot-field"
//     className="contact"
//     onSubmit={ this.handleSubmit }
//   >
//     <input type="hidden" name="form-name" value="contact" />
//
//     <div className="field">
//       <label>
//         <span>Name</span>
//         <input type="text" name="name" onChange={this.handleChange} />
//       </label>
//     </div>
//
//     <div className="field">
//       <label>
//         <span>Email</span>
//         <input type="email" name="email" onChange={this.handleChange} />
//       </label>
//     </div>
//
//     <div className="field">
//       <label>
//         <span>Message</span>
//         <textarea name="message" onChange={this.handleChange} />
//       </label>
//     </div>
//
//     <button type="submit" name="submit">Send</button>
//
//   </form>
// )

export default class Contact extends Component {

  render() {
    return (
      <Layout>
        <Helmet title="Contact Remente" />

        <h2>Contact Us</h2>
        <p>If you need help, want to provide feedback or just say hello to the Remente team, don't hesitate to get in touch!</p>
        <p>We check our e-mails on regular office hours (CEST), Monday to Friday and handle each ticket on a first-come, first-served basis.</p>

        <address>
          Remente AB<br />
          Stora Badhusgatan 18-20<br />
          411 21 Gothenburg, Sweden
          <p><SupportEmail /></p>
        </address>
      </Layout>
    )
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      })
    })
      .then(() => alert('sent!'))
      .catch(error => alert(error))
  }

}
